import { render, staticRenderFns } from "./qrInstagram.vue?vue&type=template&id=a7c6cfa2&scoped=true"
import script from "./qrInstagram.vue?vue&type=script&lang=js"
export * from "./qrInstagram.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c6cfa2",
  null
  
)

export default component.exports